<template>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <vue-alert></vue-alert>
            <div class="panel panel-default">
                <div class="panel-heading">Add Flag Half Staff Date</div>
                <div class="panel-body">
                    <form class="form-horizontal">
                        <div class="form-group">
                            <label for="" class="col-sm-2 control-label">For</label>
                            <div class="col-sm-10">
                                <select class="form-control" v-model="status.status_type" v-on:change="updateNotificationContent">
                                    <option value="AR">AR</option>
                                    <option value="US">US</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.first('start_date') }">
                            <label for="" class="col-sm-2 control-label">Start Date</label>
                            <div class="col-sm-10">
                                <date-picker :config="datePickerConfig" v-model="status.start_date" v-validate="'required'" data-vv-name="start_date" data-vv-as="start date"></date-picker>
                                <p class="help-block" v-show="errors.has('start_date')">{{ errors.first('start_date') }}</p>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.first('end_date') }">
                            <label for="" class="col-sm-2 control-label">End Date</label>
                            <div class="col-sm-10">
                                <date-picker :config="datePickerConfig" v-model="status.end_date" v-validate="'required'" data-vv-name="end_date" data-vv-as="end date"></date-picker>
                                <p class="help-block" v-show="errors.has('end_date')">{{ errors.first('end_date') }}</p>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="" class="col-sm-2 control-label">Send Notification?</label>
                            <div class="col-sm-10">
                                <input type="checkbox" value="1" v-model="status.send_notification" v-on:change="toggleNotificationFields()">
                            </div>
                        </div>
                        <div class="form-group" v-if="status.send_notification">
                            <label for="" class="col-sm-2 control-label">Notification Subject</label>
                            <div class="col-sm-10">
                                <input type="text" class="form-control" v-model="status.notification_subject" />
                            </div>
                        </div>
                        <div class="form-group" v-if="status.send_notification">
                            <label for="" class="col-sm-2 control-label">Notification Message</label>
                            <div class="col-sm-10">
                                <textarea v-model="status.notification_message" class="form-control" rows="8"></textarea>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-offset-2 col-sm-10">
                              <button v-on:click="addStatus()" type="button" class="btn btn-default btn-primary">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../app.js';
    export default {
        data() {
            return {
                status: {
                    status_type : 'AR', // default here to make things load nicely
                    start_date : null,
                    end_date : null,
                    send_notification : true,
                    notification_subject : null,
                    notification_message : null,
                    staff : 'half'
                },
                notification_templates: [],
                datePickerConfig :{
                    format: 'YYYY-MM-DD'
                }
            };
        },
        mounted() {
            this.getNotificationTemplates();
            this.$alert.setDefault({
                transition: 'smooth'
            });
        },
        methods: {
            addStatus: function(){

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        axios.post("./api/status", this.status).then(response => {
                            this.$alert.success({
                                message: 'Flag status added!'
                            });
                            this.resetStatusForm();
                            // TODO: reload listing component
                        })
                        .catch(error => {
                            if(error.response.status == 422){
                                this.$alert.danger({
                                    message: 'All fields are required.'
                                });
                            }
                            else{
                                this.$alert.danger({
                                    message: 'Error. Please try again'
                                });
                            }
                        })
                        .then(() => {
                            EventBus.$emit('status-added');
         	                this.errors.clear();
                        });
                    }
                    // got errors
                 });

            },
            getNotificationTemplates: function(){
                axios.get("./api/templates").then(response => {
                    this.notification_templates = response.data.data;
                    this.updateNotificationContent();
                });
            },
            updateNotificationContent: function(event){
                var notification = this.getNotificationByStatusType(this.status.status_type);
                this.status.notification_message = notification.body;
                this.status.notification_subject = notification.subject;
            },
            getNotificationByStatusType: function(status_type){
                return this.notification_templates.find(item => {
                    return item.status_type == status_type;
                });
            },
            toggleNotificationFields: function() {
                if(this.status.send_notification){
                    this.updateNotificationContent();
                }
                else{
                    this.status.notification_message = null;
                    this.status.notification_subject = null;
                }
            },
            resetStatusForm: function(){
                Object.assign(this.$data.status, this.$options.data().status);
                this.updateNotificationContent();
            }
        }
    }
</script>
